/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_User_Api_Key_Add_Expiration_90Inputs */



/**
* | output |
* | --- |
* | "90 days" |
*
* @param {Profile_Security_User_Api_Key_Add_Expiration_90Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_user_api_key_add_expiration_90 = /** @type {((inputs?: Profile_Security_User_Api_Key_Add_Expiration_90Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_User_Api_Key_Add_Expiration_90Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("90 Tage")
	return /** @type {LocalizedString} */ ("90 days")
});